/**
 * @module Experince/Search-Results
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Category } from '@experience/search-results/model/category.model';
import { QueryPayload } from '@experience/search-results/interfaces/search-results-payload.interface';

export class Query {
  /**
   * Main search query string (q parameter)
   */
  private searchTerm: string;

  /**
   * Keeps track of the sort type
   */
  private sortType: string;

  /**
   * Keeps track of the sort type
   */
  private pageNumber: string;

  /**
   * Keeps track of the sort type
   */
  private pageSize: string;

  /**
   * Map maintains selected category to Category Model
   */
  public selectedCategoriesMap: { [categoryTitle: string]: Category };

  constructor(searchTerm: string, pageNumber: string, pageSize: string) {
    this.searchTerm = searchTerm;
    this.pageNumber = pageNumber || '1';
    this.pageSize = pageSize || '16';
    this.selectedCategoriesMap = null;
  }

  /**
   * Function returns the main search term
   */
  public getSearchTerm(): string {
    return this.searchTerm;
  }

  /**
   * Function returns the page number
   */
  public getPageNumber(): string {
    return this.pageNumber;
  }

  /**
   * Function returns the page number
   */
  public getPageSize(): string {
    return this.pageSize;
  }

  /**
   * Function returns the sort type
   */
  public getSortType(): string {
    return this.sortType;
  }

  /**
   * Function checks if facet is selected in Query for category
   * @param category categoryTitle
   * @param facet Label/facet
   */
  public isFilterSelectedInCategory(category: string, facet: string): boolean {
    if (this.selectedCategoriesMap && this.selectedCategoriesMap[category]) {
      return this.selectedCategoriesMap[category].isFacetSelected(facet);
    } else {
      return false;
    }
  }

  /**
   * Function checks if sort option is selected
   * @param sortValue Sort value
   */
  public isSortOptionSelected(sortValue: string): boolean {
    return this.sortType === sortValue;
  }

  /**
   * Function changes sortType for queries
   * @param sortType new sortType
   */
  public changeSortType(sortType: string): void {
    this.sortType = sortType;
  }

  /**
   * Function adds filter label to a given category
   * @param category Category
   * @param label Label within category
   */
  public addFilter(category: string, label: string): void {
    console.log(this.selectedCategoriesMap);
    if (!this.selectedCategoriesMap) {
      this.selectedCategoriesMap = {};
      this.selectedCategoriesMap[category] = new Category(category);
    } else if (!this.selectedCategoriesMap[category]) {
      this.selectedCategoriesMap[category] = new Category(category);
    }
    this.selectedCategoriesMap[category].addLabel(label);
  }

  /**
   * Function removes filter label from given category
   * @param category Category
   * @param label Label within category
   */
  public removeFilter(category: string, label: string): void {
    if (this.selectedCategoriesMap && this.selectedCategoriesMap[category]) {
      const allFiltersRemoved = this.selectedCategoriesMap[category].removeLabel(label);
      if (allFiltersRemoved) {
        delete this.selectedCategoriesMap[category];
        const remainingMaps = Object.keys(this.selectedCategoriesMap);
        if (!remainingMaps.length) {
          this.selectedCategoriesMap = null;
        }
      }
    }
  }

  /**
   * Function retrieves the queryPayload for the selected search term
   */
  public retriveQueryPayload(): QueryPayload {
    const queryPayload: QueryPayload = {
      q: this.searchTerm || null,
      type: 'global',
      pageNum: this.pageNumber,
    };
    if (this.sortType) {
      queryPayload.sort = this.sortType;
      queryPayload.i = '1';
    }
    let index = 1;
    if (this.selectedCategoriesMap) {
      for (const category in this.selectedCategoriesMap) {
        if (this.selectedCategoriesMap.hasOwnProperty(category)) {
          queryPayload['x'.concat(index.toString())] = category;
          queryPayload['p'.concat(index.toString())] =
            this.selectedCategoriesMap[category].getLabelQuery();
          index++;
        }
      }
    }
    return queryPayload;
  }
}
